import React from 'react';

import env from 'Env';

import 'Components/Card/HitCardPopup/HitCardPopupCriticScore.scss';

const HitCardPopupCriticScore = ({
  metaCriticScore = 0,
}) => {
  let reviewScore = 0;
  const recommendedThreshold = env.percentRecommendedThreshold;

  const reviewImgLink = 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-icon.svg';
  const reviewImgAlt = 'Metacritic';

  if (metaCriticScore >= recommendedThreshold) {
    reviewScore = metaCriticScore;
  }

  const showCriticScore = reviewScore >= recommendedThreshold;
  if (!showCriticScore) return false;

  return (
    <div
      className="HitCardPopupCriticScore"
    >
      <div className="HitCardPopupCriticScore__score">
        {reviewScore}
      </div>
      <div className="HitCardPopupCriticScore__logo">
        <img
          src={reviewImgLink}
          width="100px"
          alt={reviewImgAlt}
        />
      </div>
    </div>
  );
};

export default HitCardPopupCriticScore;
